module.exports = __webpack_public_path__ + "static/media/TEMPLATE5.a4bce3f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/TEMPLATE5.jpg
// module id = 1471
// module chunks = 1